<template>
  <div class="comparison-skill-page">
    <div class="skill-name">技能分析</div>
    <div class="skill-content">
      <div class="overflow-content">
        
        <div class="titles">
          <div class="skill-title">
            <p>对方的优势技能</p>
          </div>
          <div class="skill-title">
            <p>我的优势技能</p>
          </div>
        </div>
        <div class="flexBox">
        <div class="skill-box">
          <div class="skill-list">
            <template v-if="skill.comparison.length > 0">
              <div class="skill-item" v-for="item in skill.comparison.filter(item => !skill.me.includes(item) && item != '其他')" :key="item + 'comparison'">{{item}}</div>
            </template>
            <p v-else class="skill-item-p-noskill">
              <img src="https://files.wondercv.com/PC/editor/planning/company/default.png" alt="">
            </p>
          </div>
        </div>
        <div class="skill-box">
          <div class="skill-list">
            <template v-if="skill.me.length > 0">
              <div class="skill-item" v-for="item in skill.me.filter(item => !skill.comparison.includes(item) && item != '其他')" :key="item + 'me'">{{item}}</div>
            </template>
            <p v-else class="skill-item-p-noskill">
              <img src="https://files.wondercv.com/PC/editor/planning/company/default.png" alt="">
              暂未发现优势技能
            </p>
          </div>
        </div>
        </div>
        <div class="public">
          <div class="skill-title">
            共同掌握的技能
          </div>
          <div class="skill-list">
            <template v-if="skill.me.filter(item=>skill.comparison.includes(item)).length > 0">
              <div class="skill-item" v-for="item in skill.me.filter(item=>skill.comparison.includes(item) && item != '其他')" :key="item + 'common'">{{item}}</div>
            </template>
            <p v-else class="skill-item-p">暂无</p>
          </div>
        </div>
        <div class="footer">
          <div class="footer-left">
            <p class="title">简历总结</p>
            <p v-if="skillToList.length > 0">你的简历中缺少<span class="differenceSkill"> {{skillToList.join("、")}}</span> 技能，建议参考大牛案例，补充相关的关键词。</p>
            <p v-else>参考大牛案例，让简历更完美。</p>
          </div>
          <div class="footer-right">
            <div class="right-title">
              <span class="iconfont icondaniumoban"></span>
              <p>大牛简历案例</p>
            </div>
            <p class="right-info">以拿到 offer 的简历分享，对照修改简历成功率翻倍</p>
            <div class="right-button" @click="goBigMoo">
              <p>立即查看</p>
              <span class="iconfont iconyou1"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "comparison-skill",
    props: {
      familyName: String,
      skill: {
        type: Object,
        default: ()=>{
          return {
            me: [],
            comparison: []
          }
        }
      }
    },
    data(){
      return {
        skillToList:[]
      }
    },
    mounted(){
      setTimeout(()=>{
        let newArr = this.skill.comparison.filter(x => this.skill.me.indexOf(x) == -1)
        newArr.indexOf("其他") > -1 ? newArr.splice(newArr.indexOf("其他"),1) : ''
        this.skillToList = newArr.slice(0,2)

      },1000)
      
    },
    methods:{
      goBigMoo(){
        let url = process.env.NODE_ENV === 'production' ? 'https://www.wondercv.com/jianlimoban/': 'https://www.wondercv.cn/jianlimoban/'
        window.open(url)
      }
    }
  }
</script>

<style scoped lang="scss">
.comparison-skill-page{
  margin-bottom: 50px;
  .skill-name{
    font-size: 32px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 45px;
    margin-bottom: 34px;
  }
  .skill-content{
    width: 1200px;
    height: 558px;
    box-shadow: 0px 2px 48px 0px rgba(25, 28, 36, 0.5);
    border-radius: 12px;
    background-image: url("https://files.wondercv.com/PC/editor/planning/people/bgcard_skillsmin.png");
    background-size: 100% 100%;
    padding: 32px;
    box-sizing: border-box;
    overflow-y: scroll;
    .overflow-content{
      width: 100%;
      height: 100%;
      overflow-y: auto;
      &::-webkit-scrollbar{
        display: none;
      }
      .skill-box{
        width: 552px;
        background: #252830;
        border-radius: 8px;
        padding: 24px 15px 12px 15px;
        // display: flex;
        box-sizing: border-box;
        align-items: flex-start;
        margin-bottom: 29px;
        height: 190px;
        overflow-y: scroll;
        // &.public{
        //   background: linear-gradient(135deg, #2C3446 0%, #21242B 100%);
        // }
        .skill-title{
          // display: flex;
          // align-items: center;
          // width: 122px;
          // min-width: 122px;
          // height: 34px;
          text-align: center;
          & > .iconfont{
            font-size: 18px;
            margin-right: 8px;
            &.iconwancheng{
              color: #7ada95;
            }
            &.iconcha{
              color: #FE7B5D;
            }
          }
          font-size: 14px;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 20px;
        }
        .skill-list{
          display: flex;
          flex-flow: row wrap;
          justify-content: flex-start;
          // flex-wrap: wrap;
          align-items: flex-start;
          transition: all 0.3s linear;
          box-sizing: border-box;
          .skill-item{
            width: 156px;
            height: 34px;
            // padding: 9px 15px;
            font-size: 14px;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 14px;
            // border: 1px solid rgba(255, 255, 255, 0.3);
            box-sizing: border-box;
            border-radius: 17px;
            margin-right: 9px;
            margin-left: 9px;
            margin-bottom: 12px;
            text-align: center;
            line-height: 34px;
            background: #2B2F38;
          }
          .skill-item-p{
            line-height: 34px;
            color: #fff;
            margin-bottom: 12px;
          }
          .skill-item-p-noskill{
            margin: 0 auto;
            color: #fff;
            img{
              display: block;
              width: 74px;
              height: 74px;
              margin: 0 auto;
              margin-top: 16px;
              margin-bottom: 12px;
            }
          }
        }
        
      }
      .skill-box::-webkit-scrollbar{
        display: none;
      }
    }
  }
  .skill-content::-webkit-scrollbar{
    display: none;
  }
}
.flexBox{
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.titles{
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  align-items: center;
  color: #FFFFFF;
  font-size: 16px;
  margin-bottom: 20px;
}
.public{
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  font-size: 16px;
  line-height: 22px;
  color: #fff;
  background: #252830;
  border-radius: 8px;
  padding: 24px;
  .skill-title{
    margin-right: 20px;
    // margin-top: 5px;
  }
  .skill-list{
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .skill-item{
    padding: 10px 24px;
    font-size: 14px;
    line-height: 14px;
    background: #31384A;
    border-radius: 17px;
    margin-right: 16px;
  }
}
.footer{
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  color: #fff;
  margin-top: 28px;
  .footer-left{
    width: 740px;
    height: 132px;
    padding: 22px 24px;
    background: #252830;
    border-radius: 8px;
    box-sizing: border-box;
    .title{
      font-size: 18px;
      margin-bottom: 14px;
    }
    .differenceSkill{
      color:#FF8569 ;
    }
  }
  .footer-right{
    width: 364px;
    height: 132px;
    background: #252830;
    border-radius: 12px;
    margin-left: 32px;
    padding: 21px 24px;
    box-sizing: border-box;
    .right-title{
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-start;
      align-items: center;
      p{
        margin-left: 9px;
        font-size: 16px;
      }
      .iconfont{
        font-size: 17px;
      }
    }
    .right-info{
      font-size: 12px;
      display: block;
      margin-left: 26px;
      margin-top: 8px;
    }
    .right-button{
      display: flex;
      flex-flow: row nowrap;
      justify-content: center;
      align-items: center;
      width: 143px;
      height: 38px;
      background: linear-gradient(180deg, #FF9F79 0%, #FF6644 100%);
      border-radius: 20px;
      margin-top: 15px;
      margin-left: 27px;
      font-size: 14px;
      cursor: pointer;
      p{
        margin-right: 6px;
      }
      .iconfont{
        font-size: 17px;
      }
    }
  }
}
</style>
